<template>
	<span :class="clazzez" :style="stylez" v-bind="extraAttrs" v-html="icon.entity"></span>
</template>

<script setup lang="ts">
import {computed} from "vue";
import { Icon, StyledIcon } from "anneca-symbols";

const props = defineProps<{
	name: string
}>();

const icon = computed<StyledIcon>(() => {
	return Icon.parse(props.name);
});

const clazzez = computed(() => {
	const c:string[] = ['fi'];
	const i = icon.value;
	if (i.clazz) c.push(i.clazz);
	return c;
});

const stylez = computed(() => {
	return icon.value.style;
});

const extraAttrs = computed(() => {
	const a = {};
	if (icon.value.id) a['id'] = icon.value.id;
	const am = icon.value.attrs;
	am.forEach((value, key) => {
		a[key] = value;
	})
	return a;
});
</script>
